import { useAnalyticsStore } from '@/store/analytics.store';
import { PIPELINE_COLUMNS } from '@/types/pipeline';
import '@/styles/analytics.css';

export function ApplicationFunnel() {
  const funnel = useAnalyticsStore((s) => s.funnel);

  const maxCount = Math.max(
    funnel.saved,
    funnel.applied,
    funnel.interview,
    funnel.offer,
    funnel.rejected,
    1 // avoid division by zero
  );

  const totalJobs = funnel.saved + funnel.applied + funnel.interview + funnel.offer + funnel.rejected;

  if (totalJobs === 0) {
    return (
      <div className="application-funnel">
        <h2 className="application-funnel__title">Application Funnel</h2>
        <div className="application-funnel__empty">
          <svg className="application-funnel__empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M22 2L2 8.5l7.5 3.5L13 22l3.5-9.5L22 2z" />
          </svg>
          <p className="application-funnel__empty-text">
            Add jobs to see your application funnel
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="application-funnel">
      <h2 className="application-funnel__title">Application Funnel</h2>
      <div className="application-funnel__rows">
        {PIPELINE_COLUMNS.map((col) => {
          const count = funnel[col.id];
          const widthPercent = (count / maxCount) * 100;

          return (
            <div key={col.id} className="funnel-row">
              <span className="funnel-row__label">{col.title}</span>
              <div className="funnel-row__bar-track">
                <div
                  className="funnel-row__bar-fill"
                  style={{
                    width: `${widthPercent}%`,
                    backgroundColor: col.color,
                  }}
                />
              </div>
              <span className="funnel-row__count">{count}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
